// React
import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// Components
import Form from "./Form";
// Material UI
import ModalBox from "../../../../ui/ModalBox";
// Providers
import { useVendor } from "../Provider";

const Edit = () => {
  const navigate = useNavigate();
  let params = useParams();
  const id = params.id;
  const {
    state: { selected },
    fetchOne: fetchVendor,
  } = useVendor();
  const [vendor, setVendor] = useState(selected);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchVendor(id);
  }, [id, fetchVendor]);

  useEffect(() => {
    setVendor(selected);
  }, [selected]);

  const handleSuccess = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  
  if (!vendor) return;
  if (vendor?.id != id) return;
  return (
    <div>
      <div
        style={{
          fontSize: "14px",
          fontWeight: "600",
        }}
      >
        Edit Vendor
      </div>
      <div>
        <Form item={vendor} handleSuccess={handleSuccess} />
      </div>
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.. You modified the vendor "
        name={vendor?.name}
      />
    </div>
  );
};

export default React.memo(Edit);
